import React, { memo } from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

let LineBreak = (props) => (
	<SvgIcon {...props} viewBox={"0 0 24 24"}>
		<path d="M24 12c-7.996 0.542-16.005 0.538-24 0 7.995-0.538 16.004-0.542 24 0Z"></path>
	</SvgIcon>
);
LineBreak = memo(LineBreak);
LineBreak.displayName = "LineBreak";
LineBreak.muiName = "LineBreak";

export default LineBreak;
